// Generated by purs version 0.15.16
import * as API_Attachments from "../API.Attachments/index.js";
import * as API_Autofill from "../API.Autofill/index.js";
import * as API_Comments from "../API.Comments/index.js";
import * as API_Document from "../API.Document/index.js";
import * as API_Pagination from "../API.Pagination/index.js";
import * as API_RecentForms from "../API.RecentForms/index.js";
import * as API_SelStudent from "../API.SelStudent/index.js";
import * as API_Signature from "../API.Signature/index.js";
import * as App_Msg from "../App.Msg/index.js";
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as App_State from "../App.State/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as $$Error from "../Error/index.js";
import * as Form_StudentSelect from "../Form.StudentSelect/index.js";
import * as GraphQL_Join from "../GraphQL.Join/index.js";
import * as GraphQL_Query from "../GraphQL.Query/index.js";
import * as GraphQL_Type from "../GraphQL.Type/index.js";
import * as Internal_Luxon from "../Internal.Luxon/index.js";
import * as Steps_FormPicker from "../Steps.FormPicker/index.js";
import * as Steps_Step1_State from "../Steps.Step1.State/index.js";
import * as Steps_Step1_Update from "../Steps.Step1.Update/index.js";
import * as Steps_Step3_State from "../Steps.Step3.State/index.js";
import * as Steps_Step3_Types from "../Steps.Step3.Types/index.js";
import * as Steps_Step3_Update from "../Steps.Step3.Update/index.js";
import * as Steps_WorkQueue_State from "../Steps.WorkQueue.State/index.js";
import * as Widgets_Search from "../Widgets.Search/index.js";
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var runGraphQL = /* #__PURE__ */ GraphQL_Join.runGraphQL(GraphQL_Query.qgql);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var gDecodeJsonCons = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Internal_Luxon.decodeLDT));
var created_atIsSymbol = {
    reflectSymbol: function () {
        return "created_at";
    }
};
var gDecodeJsonCons1 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(Data_Argonaut_Decode_Class.gDecodeJsonNil)(created_atIsSymbol)()())())));
var gDecodeJsonCons2 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonBoolean));
var gDecodeJsonCons3 = /* #__PURE__ */ gDecodeJsonCons2(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var updateIsSymbol = {
    reflectSymbol: function () {
        return "update";
    }
};
var gDecodeJsonCons4 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons5 = /* #__PURE__ */ gDecodeJsonCons4(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var gDecodeJsonCons6 = /* #__PURE__ */ gDecodeJsonCons5(nameIsSymbol)()();
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var gDecodeJsonCons7 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ GraphQL_Type.decRNTY(Data_Argonaut_Decode_Class.decodeJsonString)));
var createIsSymbol = {
    reflectSymbol: function () {
        return "create";
    }
};
var gDecodeJsonCons8 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons3({
    reflectSymbol: function () {
        return "useDefault";
    }
})()())(updateIsSymbol)()())({
    reflectSymbol: function () {
        return "saveDefault";
    }
})()())({
    reflectSymbol: function () {
        return "request";
    }
})()())(createIsSymbol)()())()));
var relationshipIsSymbol = {
    reflectSymbol: function () {
        return "relationship";
    }
};
var keyIsSymbol = {
    reflectSymbol: function () {
        return "key";
    }
};
var emailLabelIsSymbol = {
    reflectSymbol: function () {
        return "emailLabel";
    }
};
var canIsSymbol = {
    reflectSymbol: function () {
        return "can";
    }
};
var signaturesIsSymbol = {
    reflectSymbol: function () {
        return "signatures";
    }
};
var idIsSymbol = {
    reflectSymbol: function () {
        return "id";
    }
};
var gDecodeJsonCons9 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Data_Argonaut_Decode_Class.decodeJsonString));
var gDecodeJsonCons10 = /* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(Internal_Luxon.decodeLDT));
var gDecodeJsonCons11 = /* #__PURE__ */ gDecodeJsonCons7(Data_Argonaut_Decode_Class.gDecodeJsonNil);
var gDecodeJsonCons12 = /* #__PURE__ */ gDecodeJsonCons11(keyIsSymbol)()();
var changePage = /* #__PURE__ */ API_Pagination.changePage(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons2(/* #__PURE__ */ gDecodeJsonCons3(updateIsSymbol)()())({
    reflectSymbol: function () {
        return "lock";
    }
})()())()))(/* #__PURE__ */ gDecodeJsonCons1(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons6)()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldMaybe(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons5({
    reflectSymbol: function () {
        return "company";
    }
})()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5({
    reflectSymbol: function () {
        return "url";
    }
})()())(labelIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons5(updateIsSymbol)()())({
    reflectSymbol: function () {
        return "delete";
    }
})()())(createIsSymbol)()())()))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(Data_Argonaut_Decode_Class.decodeJsonInt))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons5({
    reflectSymbol: function () {
        return "relationship_label";
    }
})()())(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())(canIsSymbol)()())())))(/* #__PURE__ */ gDecodeJsonCons5({
    reflectSymbol: function () {
        return "type";
    }
})()())(signaturesIsSymbol)()())({
    reflectSymbol: function () {
        return "priority";
    }
})()())({
    reflectSymbol: function () {
        return "mutations";
    }
})()())(labelIsSymbol)()())(idIsSymbol)()())({
    reflectSymbol: function () {
        return "bgColor";
    }
})()())({
    reflectSymbol: function () {
        return "abbr";
    }
})()())()))(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons10(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons8(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons11(relationshipIsSymbol)()())(labelIsSymbol)()())(keyIsSymbol)()())(emailLabelIsSymbol)()())({
    reflectSymbol: function () {
        return "default_last_name";
    }
})()())({
    reflectSymbol: function () {
        return "default_first_name";
    }
})()())({
    reflectSymbol: function () {
        return "default_email";
    }
})()())(canIsSymbol)()())())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(gDecodeJsonCons12)())))(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons7(/* #__PURE__ */ gDecodeJsonCons10(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons9(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons6)({
    reflectSymbol: function () {
        return "color";
    }
})()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "tags";
    }
})()())({
    reflectSymbol: function () {
        return "preferred_name";
    }
})()())(nameIsSymbol)()())({
    reflectSymbol: function () {
        return "last_imported_at";
    }
})()())(idIsSymbol)()())()))(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ gDecodeJsonCons4(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeArray(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.gDecodeJsonCons(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeFieldId(/* #__PURE__ */ Data_Argonaut_Decode_Class.decodeRecord(/* #__PURE__ */ gDecodeJsonCons4(gDecodeJsonCons12)({
    reflectSymbol: function () {
        return "email";
    }
})()())()))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "data";
    }
})()())(created_atIsSymbol)()())())))(Data_Argonaut_Decode_Class.gDecodeJsonNil)({
    reflectSymbol: function () {
        return "verifications";
    }
})()())({
    reflectSymbol: function () {
        return "updated_at";
    }
})()())({
    reflectSymbol: function () {
        return "subtitle";
    }
})()())({
    reflectSymbol: function () {
        return "student";
    }
})()())(signaturesIsSymbol)()())({
    reflectSymbol: function () {
        return "signature_fields";
    }
})()())({
    reflectSymbol: function () {
        return "locked_at";
    }
})()())({
    reflectSymbol: function () {
        return "legacy_url";
    }
})()())(idIsSymbol)()())({
    reflectSymbol: function () {
        return "form_type";
    }
})()())({
    reflectSymbol: function () {
        return "exports";
    }
})()())({
    reflectSymbol: function () {
        return "employer";
    }
})()())({
    reflectSymbol: function () {
        return "contact";
    }
})()())({
    reflectSymbol: function () {
        return "comments";
    }
})()())(canIsSymbol)()())({
    reflectSymbol: function () {
        return "attachments";
    }
})()())());
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map2 = /* #__PURE__ */ Data_Functor.map(Effect_Aff.functorAff);
var map3 = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var getQuery = /* #__PURE__ */ GraphQL_Join.getQuery(GraphQL_Query.joinGenQ);
var bind1 = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Effect_Aff.monadAff));
var except = /* #__PURE__ */ Control_Monad_Except_Trans.except(Effect_Aff.applicativeAff);
var getDecode = /* #__PURE__ */ GraphQL_Join.getDecode(GraphQL_Query.joinGenQ);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Effect_Aff.monadAff));
var bind2 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var operationMessages = function (opId) {
    return function (result) {
        return function (payload) {
            var statusMessage = (function () {
                if (result instanceof Data_Either.Left) {
                    return new App_Msg.OpFailed(opId, result.value0);
                };
                if (result instanceof Data_Either.Right) {
                    return new App_Msg.OpCompleted(opId);
                };
                throw new Error("Failed pattern match at App.Operation.Runner (line 302, column 21 - line 304, column 36): " + [ result.constructor.name ]);
            })();
            return append(payload)([ statusMessage ]);
        };
    };
};
var runAutofillStep3 = function (enqueue) {
    return function (opId) {
        return function (kind) {
            return function (args) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, kind, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(runGraphQL(API_Autofill.autofillData(args)))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3Msg(new Steps_Step3_Update.AutofillCompleted(opId, result$prime)) ])));
                    }))();
                };
            };
        };
    };
};
var runLoadStep3 = function (enqueue) {
    return function (state) {
        return function (opId) {
            return function (kind) {
                return function (target) {
                    return function __do() {
                        enqueue([ new App_Msg.OpStarted(opId, kind, new Data_Maybe.Just(target.generation)) ])();
                        return Effect_Aff.launchAff_(bind((function () {
                            if (state.step3 instanceof App_State.Step3Ready) {
                                return Steps_Step3_State.loadTargetStep3State(state.step3.value0)(Data_Maybe.Nothing.value);
                            };
                            return pure(new Data_Either.Left(new $$Error.StringError("Step 3 load requested without a ready Step 3 session.")));
                        })())(function (result$prime) {
                            var editorResult = map(function (v) {
                                return v.editor;
                            })(result$prime);
                            return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3Msg(new Steps_Step3_Update.LoadCompleted(opId, target.generation, editorResult)) ])));
                        }))();
                    };
                };
            };
        };
    };
};
var runSaveStep3 = function (enqueue) {
    return function (state) {
        return function (opId) {
            return function (kind) {
                return function (generation) {
                    return function __do() {
                        enqueue([ new App_Msg.OpStarted(opId, kind, generation) ])();
                        return Effect_Aff.launchAff_(bind((function () {
                            if (state.step3 instanceof App_State.Step3Ready) {
                                return Steps_Step3_State.saveCurrentDocument(state.step3.value0);
                            };
                            return pure(new Data_Either.Left(new $$Error.StringError("Step 3 save requested without a ready Step 3 session.")));
                        })())(function (result$prime) {
                            return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3Msg(new Steps_Step3_Update.SaveCompleted(opId, result$prime)) ])));
                        }))();
                    };
                };
            };
        };
    };
};
var runStep1CopyDocuments = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function (requests) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.CopyRecentForms(Steps_Step1_State.selectedDocumentIds(ready)), Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(runGraphQL(API_Document.copyDocuments(requests)))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1DocumentsCopied(opId, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep1CurrentPageReload = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadRecentForms.value, Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(changePage(API_Pagination.pageNumber(ready.recentForms))(ready.recentForms))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1RecentFormsLoaded(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1DeleteDocuments = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.DeleteRecentForms(Steps_Step1_State.selectedDocumentIds(ready)), Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(runGraphQL(API_Document.deleteDocuments(Steps_Step1_State.selectedDocumentIds(ready))))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1DocumentsDeleted(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1ExportDocuments = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function (etype) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.ExportRecentForms(Steps_Step1_State.selectedDocumentIds(ready)), Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(runGraphQL(API_Document.exportDocuments(Steps_Step1_State.selectedDocumentIds(ready))))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1DocumentsExported(opId, etype, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep1InitialLoad = function (enqueue) {
    return function (opId) {
        return function (initial) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadRecentForms.value, Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(Steps_Step1_State.initRecentFormState(initial))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1InitialLoaded(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1PageChange = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function (idx) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadRecentForms.value, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(changePage(idx)(ready.recentForms))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1RecentFormsLoaded(opId, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep1RequestSignatures = function (enqueue) {
    return function (opId) {
        return function (requests) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.RequestRecentFormSignatures(map1(function (v) {
                    return v.docId;
                })(requests)), Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(runGraphQL(API_Signature.requestSigs(requests)))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1SignaturesRequested(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1SaveFormOrder = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.SaveStep1FormOrder.value, Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(Steps_FormPicker.endFormReorder(ready.formPicker))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1FormOrderSaved(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1Search = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadRecentForms.value, Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind(runGraphQL(API_RecentForms.searchRecentForms(Steps_Step1_State.rfSearchQuery(ready))))(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1RecentFormsLoaded(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1ToggleLocks = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function __do() {
                enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.BulkToggleDocumentLocks(Steps_Step1_State.selectedDocumentIds(ready)), Data_Maybe.Nothing.value) ])();
                return Effect_Aff.launchAff_(bind((function () {
                    var v = Steps_Step1_Update.toggleLockRequests(ready);
                    if (v instanceof Data_Maybe.Nothing) {
                        return pure(new Data_Either.Left(new $$Error.StringError("Step 1 lock toggle requested without lockable selected documents.")));
                    };
                    if (v instanceof Data_Maybe.Just) {
                        return runGraphQL(API_Document.toggleDocumentLocks(v.value0));
                    };
                    throw new Error("Failed pattern match at App.Operation.Runner (line 102, column 20 - line 104, column 71): " + [ v.constructor.name ]);
                })())(function (result$prime) {
                    return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1LocksToggled(opId, result$prime) ])));
                }))();
            };
        };
    };
};
var runStep1UpdateForms = function (enqueue) {
    return function (opId) {
        return function (ready) {
            return function (selection) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, new App_Operation_Types.UpdateRecentForms(Steps_Step1_State.selectedDocumentIds(ready)), Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(runGraphQL(Steps_Step1_Update.runUpdateFormsMutation(selection)(Steps_Step1_State.selectedForms(ready))))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step1FormsUpdated(opId, selection, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep2AInitialLoad = function (enqueue) {
    return function (opId) {
        return function (workQueueState) {
            return function (workQueueCache) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadStep2Students.value, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_((function () {
                        var selectState = Form_StudentSelect.initState(workQueueState)(workQueueCache);
                        return bind(map2(map(function (page) {
                            return Form_StudentSelect.updatePage(page)(selectState);
                        }))(runGraphQL(API_SelStudent.searchStudents(Widgets_Search.stateToQuery(selectState.search)))))(function (result$prime) {
                            return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step2AInitialLoaded(opId, result$prime) ])));
                        });
                    })())();
                };
            };
        };
    };
};
var runStep2BLoad = function (enqueue) {
    return function (opId) {
        return function (workQueueState) {
            return function (workQueueUi) {
                return function (workQueueCache) {
                    return function __do() {
                        enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadStep2FormPicker.value, Data_Maybe.Nothing.value) ])();
                        return Effect_Aff.launchAff_(bind(runGraphQL(Steps_FormPicker.loadFormPicker(workQueueState)(workQueueUi)(workQueueCache)))(function (result$prime) {
                            return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step2BLoaded(opId, result$prime) ])));
                        }))();
                    };
                };
            };
        };
    };
};
var runStep2ExportAll = function (enqueue) {
    return function (opId) {
        return function (workQueueState) {
            return function (workQueueCache) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.ExportStep2Forms.value, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(Steps_WorkQueue_State.createAllForms(workQueueState)(map3(function (v) {
                        return v.value;
                    })(workQueueCache.defTeacher))(map3(function (v) {
                        return v.value;
                    })(workQueueCache.defSemester)))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step2FormsExported(opId, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep3FormTypesLoad = function (enqueue) {
    return function (state) {
        return function (opId) {
            return function (init) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, App_Operation_Types.LoadStep3FormTypes.value, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(Steps_Step3_State.preloadStep3Resources(state.workQueueState)(state.workQueueCache)(init.formType)(init.doc))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3FormTypesLoaded(opId, result$prime) ])));
                    }))();
                };
            };
        };
    };
};
var runStep3InitialLoad = function (enqueue) {
    return function (state) {
        return function (opId) {
            return function (kind) {
                return function (init) {
                    return function __do() {
                        enqueue([ new App_Msg.OpStarted(opId, kind, Data_Maybe.Nothing.value) ])();
                        return Effect_Aff.launchAff_(bind(Steps_Step3_State.loadInitialStep3State(state.workQueueState)(state.workQueueUi)(state.workQueueCache)(init.doc)(init.initialAnchor))(function (result$prime) {
                            return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3InitialLoaded(opId, result$prime) ])));
                        }))();
                    };
                };
            };
        };
    };
};
var multiResponseAt = function (operation) {
    return function (idx) {
        return function (responses) {
            var v = Data_Array.index(responses)(idx);
            if (v instanceof Data_Maybe.Just) {
                return new Data_Either.Right(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return new Data_Either.Left(new $$Error.StringError(operation + " was missing from the batched GraphQL response."));
            };
            throw new Error("Failed pattern match at App.Operation.Runner (line 294, column 43 - line 296, column 99): " + [ v.constructor.name ]);
        };
    };
};
var runSignAndRefresh = function (docId) {
    return function (signQuery) {
        return Control_Monad_Except_Trans.runExceptT((function () {
            var uploads = GraphQL_Query.queryUploads(signQuery);
            var refreshQuery = API_Signature.fetchSignatureRefresh(docId);
            var queries = [ getQuery(signQuery), getQuery(refreshQuery) ];
            return bind1((function () {
                var v = Data_Array.length(uploads);
                if (v === 0) {
                    return GraphQL_Join.runMultiQuery(queries);
                };
                if (v === 1) {
                    var v1 = Data_Array.index(uploads)(0);
                    if (v1 instanceof Data_Maybe.Just) {
                        return GraphQL_Join.runMultiQueryWithUpload(queries)({
                            name: v1.value0.name,
                            file: v1.value0.file,
                            path: "0.variables." + v1.value0.path
                        });
                    };
                    if (v1 instanceof Data_Maybe.Nothing) {
                        return except(new Data_Either.Left(new $$Error.StringError("Expected one signature upload, but none was available.")));
                    };
                    throw new Error("Failed pattern match at App.Operation.Runner (line 278, column 14 - line 284, column 101): " + [ v1.constructor.name ]);
                };
                return except(new Data_Either.Left(new $$Error.StringError("Multiple file uploads are not currently supported")));
            })())(function (responses) {
                return bind1(except(multiResponseAt("signForm")(0)(responses)))(function (signatureJson) {
                    return bind1(except(multiResponseAt("GetDocument")(1)(responses)))(function (refreshJson) {
                        return bind1(except(getDecode(signQuery)(signatureJson)))(function (signature) {
                            return bind1(except(getDecode(refreshQuery)(refreshJson)))(function (refresh) {
                                return pure1(new Steps_Step3_Types.SignatureSignedAndRefreshed(signature, refresh));
                            });
                        });
                    });
                });
            });
        })());
    };
};
var runStep3DocumentMutationRequest = function (v) {
    if (v instanceof Steps_Step3_Types.CreateComment) {
        return map2(map(Steps_Step3_Types.CommentCreated.create))(runGraphQL(API_Comments.postComment(new API_Comments.FormComment(v.value0))(v.value1)));
    };
    if (v instanceof Steps_Step3_Types.UpdateComment) {
        return map2(map(Steps_Step3_Types.CommentUpdated.create))(runGraphQL(API_Comments.updateComment(v.value1)(v.value2)));
    };
    if (v instanceof Steps_Step3_Types.DeleteComment) {
        return map2(map(function ($448) {
            return Steps_Step3_Types.CommentDeleted.create((function (v1) {
                return v1.id;
            })($448));
        }))(runGraphQL(API_Comments.deleteComment(v.value1)));
    };
    if (v instanceof Steps_Step3_Types.CreateAttachment) {
        return map2(map(Steps_Step3_Types.AttachmentCreated.create))(runGraphQL(API_Attachments.postAttachment(new API_Attachments.FormAttachment(v.value0))(v.value1)));
    };
    if (v instanceof Steps_Step3_Types.DeleteAttachment) {
        return map2(map(function ($449) {
            return Steps_Step3_Types.AttachmentDeleted.create((function (v1) {
                return v1.id;
            })($449));
        }))(runGraphQL(API_Attachments.deleteAttachment(v.value1)));
    };
    if (v instanceof Steps_Step3_Types.SignWithCapturedSignature) {
        return runSignAndRefresh(v.value0)(API_Signature.signForm(v.value0)(v.value1)(v.value2)(v.value3));
    };
    if (v instanceof Steps_Step3_Types.SignWithSavedSignature) {
        return runSignAndRefresh(v.value0)(API_Signature.signWithSaved(v.value0)(v.value1));
    };
    if (v instanceof Steps_Step3_Types.RefreshSignatureGroup) {
        return map2(map(Steps_Step3_Types.SignatureGroupRefreshed.create))(runGraphQL(API_Signature.fetchSignatureRefresh(v.value0)));
    };
    if (v instanceof Steps_Step3_Types.RequestSignatures) {
        return map2(map(Steps_Step3_Types.SignaturesRequested.create))(runGraphQL(API_Signature.requestSigs(v.value0)));
    };
    throw new Error("Failed pattern match at App.Operation.Runner (line 239, column 35 - line 265, column 81): " + [ v.constructor.name ]);
};
var runStep3DocumentMutation = function (enqueue) {
    return function (opId) {
        return function (kind) {
            return function (request) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, kind, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind(runStep3DocumentMutationRequest(request))(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3Msg(new Steps_Step3_Update.DocumentMutationCompleted(opId, result$prime)) ])));
                    }))();
                };
            };
        };
    };
};
var firstLockResult = function (results) {
    var v = Data_Array.index(results)(0);
    if (v instanceof Data_Maybe.Just) {
        return new Data_Either.Right(v.value0);
    };
    if (v instanceof Data_Maybe.Nothing) {
        return new Data_Either.Left(new $$Error.StringError("ToggleDocumentLocks returned no updated documents."));
    };
    throw new Error("Failed pattern match at App.Operation.Runner (line 307, column 27 - line 309, column 87): " + [ v.constructor.name ]);
};
var runToggleStep3Lock = function (enqueue) {
    return function (state) {
        return function (opId) {
            return function (kind) {
                return function __do() {
                    enqueue([ new App_Msg.OpStarted(opId, kind, Data_Maybe.Nothing.value) ])();
                    return Effect_Aff.launchAff_(bind((function () {
                        if (state.step3 instanceof App_State.Step3Ready) {
                            var requests = [ {
                                form_id: state.step3.value0.editor.fillState.doc.id,
                                locked: Data_Maybe.isNothing(state.step3.value0.editor.fillState.doc.locked_at)
                            } ];
                            return bind(runGraphQL(API_Document.toggleDocumentLocks(requests)))(function (results) {
                                return pure(bind2(results)(firstLockResult));
                            });
                        };
                        return pure(new Data_Either.Left(new $$Error.StringError("Step 3 lock toggle requested without a ready Step 3 session.")));
                    })())(function (result$prime) {
                        return liftEffect(enqueue(operationMessages(opId)(result$prime)([ new App_Msg.Step3Msg(new Steps_Step3_Update.LockCompleted(opId, result$prime)) ])));
                    }))();
                };
            };
        };
    };
};
export {
    runStep1InitialLoad,
    runStep1Search,
    runStep1PageChange,
    runStep1CurrentPageReload,
    runStep1SaveFormOrder,
    runStep1ToggleLocks,
    runStep1CopyDocuments,
    runStep1DeleteDocuments,
    runStep1ExportDocuments,
    runStep1RequestSignatures,
    runStep1UpdateForms,
    runStep2AInitialLoad,
    runStep2BLoad,
    runStep2ExportAll,
    runStep3FormTypesLoad,
    runStep3InitialLoad,
    runSaveStep3,
    runLoadStep3,
    runAutofillStep3,
    runToggleStep3Lock,
    runStep3DocumentMutation
};
//# sourceMappingURL=index.js.map
